import { render, staticRenderFns } from "./CrmTicketShow.vue?vue&type=template&id=1a81dcf6"
import script from "./CrmTicketShow.vue?vue&type=script&lang=js"
export * from "./CrmTicketShow.vue?vue&type=script&lang=js"
import style0 from "./CrmTicketShow.vue?vue&type=style&index=0&id=1a81dcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports